import { useMemo } from "react";

import PropTypes from "prop-types";

import { ValidationBadge } from "components/form";
import { Tooltip } from "components/popups";
import { classes } from "utils/classes";

import styles from "./switch3.scss";

export function Switch3(props) {
  const {
    name,
    className,
    disabled,
    error,
    label,
    lowerCaseValueLabel = true,
    tooltip,
    touched,
    value: currentValue,
    values,
    dataTestId,
    onSelect,
    children,
  } = props;

  const valueIndex = useMemo(
    () => values.findIndex(({ value }) => value === currentValue),
    [currentValue, values]
  );

  const getSwitchPositionStyle = () => {
    if (valueIndex === 0) {
      return styles.left;
    }
    if (valueIndex === values.length - 1) {
      return styles.right;
    }
    return styles.center;
  };

  const handleClick = () => {
    if (values.length === 0) {
      return;
    }
    const nextValue = values[(valueIndex + 1) % values.length].value;
    onSelect(nextValue);
  };

  const renderLabelText = () => {
    if (typeof children === "function") {
      return children(currentValue);
    }
    if (children) {
      return children;
    }
    let valueLabel = values[valueIndex]?.label;
    if (valueLabel) {
      if (lowerCaseValueLabel) {
        valueLabel = valueLabel.toLowerCase();
      }
      return `${label} (${valueLabel})`;
    }
    return label;
  };

  return (
    <div className={className}>
      <Tooltip content={tooltip}>
        <label
          className={classes(styles.wrapper, {
            [styles.disabled]: disabled,
          })}
          htmlFor={"form-id-" + name}
        >
          <select
            id={"form-id-" + name}
            name={name}
            disabled={disabled}
            value={currentValue}
            data-test-id={dataTestId}
            onClick={handleClick}
            onChange={() => {}}
          >
            {values.map(({ label, value }) => (
              <option key={value} value={value}>
                {label || value}
              </option>
            ))}
          </select>
          <span className={classes(styles.switch, getSwitchPositionStyle())} />
          <div className={styles.label}>{renderLabelText()}</div>
        </label>
      </Tooltip>
      <ValidationBadge error={error} touched={touched} />
    </div>
  );
}

Switch3.propTypes = {
  name: PropTypes.string,

  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
  lowerCaseValueLabel: PropTypes.bool,
  tooltip: PropTypes.string,
  touched: PropTypes.bool,
  value: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  dataTestId: PropTypes.string,

  onSelect: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};
